import { gql } from '@apollo/client';

const ORDER_LIST_SELECTION = `
      nodes {
        databaseId
        orderNumber
        date
        status
        total
        currency
        metaData {
          key
          value
        }
        customer {
          databaseId
          firstName
          lastName
          email
        }
        billing {
          firstName
          lastName
          email
          phone
          country
          city
        }
        lineItems {
          nodes {
            quantity
            total
            product {
              node {
                name
              }
            }
            metaData {
              key
              value
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
`;

/**
 * WooCommerce orders list (WPGraphQL WooCommerce).
 * Staff/admin: unscoped. Customer portal uses GET_CUSTOMER_ORDERS.
 */
export const GET_ORDERS = gql`
  query GetOrders($first: Int, $after: String) {
    orders(first: $first, after: $after) {
      ${ORDER_LIST_SELECTION}
    }
  }
`;

export const GET_CUSTOMER_ORDERS = gql`
  query GetCustomerOrders($first: Int, $after: String, $where: RootQueryToOrderConnectionWhereArgs) {
    orders(first: $first, after: $after, where: $where) {
      ${ORDER_LIST_SELECTION}
    }
  }
`;

export interface OrderCustomer {
  id: string;
  databaseId?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
}

export interface OrderBilling {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
}

export interface OrderLineItemMeta {
  key: string;
  value: string;
}

export interface OrderLineItem {
  id?: string;
  productId?: number;
  quantity?: number;
  total?: string;
  product?: {
    node?: {
      id: string;
      name?: string;
      sku?: string;
    };
  };
  metaData?: OrderLineItemMeta[];
}

export interface OrderNode {
  id?: string;
  databaseId: number;
  orderNumber?: string;
  date?: string;
  status?: string;
  total?: string;
  currency?: string;
  metaData?: OrderLineItemMeta[];
  customer?: OrderCustomer | null;
  billing?: OrderBilling | null;
  lineItems?: {
    nodes: OrderLineItem[];
  };
}

export interface GetOrdersData {
  orders: {
    nodes: OrderNode[];
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
}

export interface GetOrdersVariables {
  first?: number;
  after?: string | null;
  where?: {
    customerId?: number | null;
  } | null;
}
